/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { StepConfigurationData } from './stepConfigurationData';
import { TagData } from './tagData';


/**
 * Step details
 */
export interface StepData { 
    /**
     * Indicates if the step is started automatically
     */
    auto?: boolean;
    /**
     * Step type
     */
    category?: StepData.CategoryEnum;
    /**
     * Completion date
     */
    completedOn?: Date;
    /**
     * Related configuration
     */
    configuration?: StepConfigurationData;
    /**
     * Creation date
     */
    createdOn?: Date;
    /**
     * Indicates the id of the connected enduser who has delegated at the step level, 0 otherwise
     */
    delegatorId?: number;
    /**
     * Step
     */
    id?: number;
    /**
     * Label of the step in the enduser language
     */
    label?: string;
    /**
     * Date of the last signature
     */
    lastSignedOn?: Date;
    /**
     * Last modification date
     */
    modifiedOn?: Date;
    /**
     * Owner id
     */
    ownerId?: any;
    /**
     * Priority of the step
     */
    priority?: number;
    /**
     * Rule alias
     */
    ruleAliases?: Array<string>;
    /**
     * Rule replacements
     */
    ruleReplacements?: any;
    /**
     * Session
     */
    sessionId?: number;
    /**
     * Whether to not create acroforms on step start
     */
    skipAcroforms?: boolean;
    /**
     * Start date
     */
    startedOn?: Date;
    /**
     * Step status
     */
    status?: StepData.StatusEnum;
    /**
     * Tags associated
     */
    tags?: Array<TagData>;
    /**
     * Step sub type
     */
    type?: StepData.TypeEnum;
    /**
     * Step position on X axis
     */
    x?: number;
    /**
     * Step position on Y axis
     */
    y?: number;
}
export namespace StepData {
    export type CategoryEnum = 'OPERATION' | 'OPERATOR' | 'SPOT';
    export const CategoryEnum = {
        OPERATION: 'OPERATION' as CategoryEnum,
        OPERATOR: 'OPERATOR' as CategoryEnum,
        SPOT: 'SPOT' as CategoryEnum
    };
    export type StatusEnum = 'CREATED' | 'STARTED' | 'SKIPPED' | 'COMPLETED' | 'DECLINED' | 'CANCELED' | 'SUSPENDED';
    export const StatusEnum = {
        CREATED: 'CREATED' as StatusEnum,
        STARTED: 'STARTED' as StatusEnum,
        SKIPPED: 'SKIPPED' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        DECLINED: 'DECLINED' as StatusEnum,
        CANCELED: 'CANCELED' as StatusEnum,
        SUSPENDED: 'SUSPENDED' as StatusEnum
    };
    export type TypeEnum = 'END' | 'START' | 'GATE' | 'PREPARATION' | 'STEP_OPERATION' | 'SIGNATURE' | 'VALIDATION';
    export const TypeEnum = {
        END: 'END' as TypeEnum,
        START: 'START' as TypeEnum,
        GATE: 'GATE' as TypeEnum,
        PREPARATION: 'PREPARATION' as TypeEnum,
        STEPOPERATION: 'STEP_OPERATION' as TypeEnum,
        SIGNATURE: 'SIGNATURE' as TypeEnum,
        VALIDATION: 'VALIDATION' as TypeEnum
    };
}
